export const MAX_ADDABLE_UPLOAD_IMAGE_COUNT = 14;
export const MAIN_IMAGE_COUNT = 1;
export const MAX_ALL_UPLOAD_IMAGE_COUNT = MAX_ADDABLE_UPLOAD_IMAGE_COUNT + MAIN_IMAGE_COUNT;
